import styled from 'styled-components';

import Select from '../../../../../../../components/Select';
import { StyledTextField } from '../../../../../../../components/Inputs';

const ScrollableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  gap: 12px;
  overflow-y: auto;
  max-height: 280px;
  scrollbar-width: thin;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ $gridColumns }) => `repeat(${$gridColumns}, minmax(0, 1fr))`};
  gap: 12px;
`;

const StyledSelect = styled(Select)`
  min-width: 100px;
  width: 100%;

  .MuiSelect-select {
    line-height: 2px;
  }
`;

const TextField = styled(StyledTextField)`
  .MuiInputBase-root {
    height: 35px;
  }
`;

export {
  ScrollableContainer,
  GridContainer,
  StyledSelect,
  TextField,
};
